import React, { useEffect, useState } from "react"

const Subcriptions = props => {
    return (abc)
}

export default Subcriptions
